'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />
var address;
(function (address) {
    var AddressService = function () {
        /*@ngInject*/

        function AddressService($http) {
            _classCallCheck(this, AddressService);

            this.$http = $http;
            this.api = new API.Client.AddressApi(this.$http);
        }

        _createClass(AddressService, [{
            key: 'getState',
            value: function getState(countryCode) {
                return this.api.addressesCountriesCountryCodeStatesGet(countryCode).then(function (response) {
                    return response.data.states;
                });
            }
        }, {
            key: 'getCity',
            value: function getCity(countryCode, stateCode) {
                return this.api.addressesCountriesCountryCodeStatesStateCodeCitiesGet(countryCode, stateCode).then(function (response) {
                    return response.data.cities;
                });
            }
        }, {
            key: 'getCep',
            value: function getCep(zipCode) {
                return this.api.addressesGet(zipCode).then(function (response) {
                    return response.data && response.data.addresses[0];
                });
            }
        }]);

        return AddressService;
    }();

    address.AddressService = AddressService;
    angular.module('address', []).service('addressService', AddressService);
})(address || (address = {}));